
import httpManager from "../../util/common";
import {reportYear} from '../../util/util'

export default {
  name: 'ESGReportDownloadTemplate',
  props: {
    showTitle:Boolean, 
    showCompany:Boolean,
    oaid:String
  },
  data () {
    return {
      currentOaid: null,
      followEntitySupplier: false,
      periodOptions: [],
      reportPeriod: [],
      previewData: '',
      showModal: false,
      showLoading: false,
      progressPercent: 0,
      company: '',
      onceDownload: true,
      downBtnLoading: false,
      preBtnLoading: false
    }
  },
  methods: {
    clearData() {
      this.currentOaid = null
      this.reportPeriod = []
      this.$refs.companySearch.clear()
    },
    searchData() {
      if (!this.company || Array.isArray(this.reportPeriod)) return this.$message.warning(this.$t('tips.report_download_tip'))
      this.showModal = true
      this.showLoading = true
      let timer = setInterval(() => {
        this.progressPercent += 1
        if(this.progressPercent >= 99) {
          clearInterval(timer)
        }
      }, 100);
      let params = new Map()
      let oaid = this.currentOaid
      if (this.oaid) oaid = this.oaid
      params.set('oaid', oaid)
      params.set('report_date', this.reportPeriod.replace(/\-/g, '/'))
      params.set('only_first_page', true)
      httpManager('esg_performance_report_download', params, null, { responseType: 'blob' }, null).then((res) => {
        let blob = new Blob([res.data],{type: "image/jpeg"});
        this.previewData = window.URL.createObjectURL(blob);
        this.progressPercent = 100
        clearInterval(timer)
        this.showModal = false
      }).catch(err => {
        this.showModal = false
        clearInterval(timer)
      })
    },
    downloadReport() {
      if (!this.company || Array.isArray(this.reportPeriod)) return this.$message.warning(this.$t('tips.report_download_tip'))
      // this.btnLoading = true
      this.showModal = true
      this.showLoading = true
      let timer = setInterval(() => {
        this.progressPercent += 1
        if(this.progressPercent >= 99) {
          clearInterval(timer)
        }
      }, 100);
      let params = new Map()
      let oaid = this.currentOaid
      if (this.oaid) oaid = this.oaid
      params.set('oaid', oaid)
      params.set('report_date', this.reportPeriod.replace(/\-/g, '/'))
      httpManager('esg_performance_report_download', params, null, { responseType: 'blob' }, null).then((res) => {
        let blob = new Blob([res.data], { type: "application/pdf" });
        let a = document.createElement("a");
        a.href = window.URL.createObjectURL(blob);
        a.download = `${this.company}${this.reportPeriod}ESG绩效报告.pdf`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        this.progressPercent = 100
        clearInterval(timer)
        this.showModal = false
      }).catch(err => {
        this.showModal = false
        clearInterval(timer)
      })
    },
    downloadPreReport() {

    },
    handleOk() {
      
    },
    handleCancel() {
      this.showModal = false
    },
    handleClose() {
      this.showLoading = false
      this.progressPercent = 0
    },
    changeOaid () {
      let id = this.oaid
      if (this.showTitle === true) {
        id = this.currentOaid
      }
      let params = new Map()
      params.set('oaid', id)
      httpManager('entity_basic_info', params).then((res) => {
        this.company = res.data.data.entname ? res.data.data.entname : res.data.data.entname_en
      })
    },
    generateReport(){
      let params = new Map()
      let oaid = this.currentOaid
      if (this.oaid) {
        oaid = this.oaid
      }
      params.set('oaid', oaid)
      httpManager('esg_report_period_list', params).then((res) => {
        this.periodOptions = res.data.data.map(item => item.replace(/\//g, '-'))
        this.reportPeriod = this.periodOptions[0]
      })
    },
  },
  computed: {
    lang() {
      return this.$i18n.locale
    },
    aModalTitle() {
      if (this.onceDownload) {
        if (this.showLoading === false) {
          return `${this.$t('esg.on_download')} ${this.company} ${this.reportPeriod}(${this.$t('esg.report_period')}) ${this.$t('esg.company_esg_report')}`
        } else {
          return this.$t('esg.create_esg_report')
        }
      } else {
        return `${this.$t('esg.on_downloaded')} ${this.company} ${this.reportPeriod}(${this.$t('esg.report_period')}) ${this.$t('esg.company_esg_report')} ${this.$t('esg.company_esg_report_redownload')}`
      }
    }
  },
  watch: {
    currentOaid() {
      if(this.currentOaid === null) {
        this.company = null
      }
      this.changeOaid()
      this.generateReport()
    },
    oaid() {
      this.changeOaid()
      this.generateReport()
    }
  },
  created () {
    if(this.oaid) {
      this.changeOaid()
    }
  }
}


// WEBPACK FOOTER //
// ./src/esg/js/ESGReportDownloadTemplate.js